import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import API from '../config/api';

export default function Contact() {
  const { lang, t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    try {
      const res = await fetch(API.contact.submit, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok && data.status === 'success') {
        setSubmitted(true);
      } else {
        setError(data.message || (lang === 'de' ? 'Fehler beim Senden. Bitte versuchen Sie es erneut.' : 'Failed to send. Please try again.'));
      }
    } catch (err) {
      setError(lang === 'de' ? 'Netzwerkfehler. Bitte versuchen Sie es erneut.' : 'Network error. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ct-page">
      {/* Hero */}
      <section className="ct-hero">
        <span className="ct-label">{lang === 'de' ? t('contact.hero.label') : 'GET IN TOUCH'}</span>
        <h1 className="ct-hero-title" dangerouslySetInnerHTML={{ __html: lang === 'de' ? t('contact.hero.title') : "We'd Love to<br />Hear From You" }}></h1>
        <p className="ct-hero-sub">{lang === 'de' ? t('contact.hero.sub') : "Questions about our rugs, custom orders, or trade program? We're here to help."}</p>
      </section>

      {/* Contact Grid */}
      <section className="ct-main">
        <div className="ct-info-col">
          <div className="ct-info-block">
            <h3 className="ct-info-title">{lang === 'de' ? t('contact.info.showroom') : 'Visit Our Showroom'}</h3>
            <p className="ct-info-text">Bhadohi, Uttar Pradesh<br/>India 221401</p>
          </div>
          <div className="ct-info-block">
            <h3 className="ct-info-title">{lang === 'de' ? t('contact.info.email') : 'Email Us'}</h3>
            <p className="ct-info-text"><a href="mailto:support@kaaleenhaus.com">support@kaaleenhaus.com</a></p>
            <p className="ct-info-text"><a href="mailto:orders@kaaleenhaus.com">orders@kaaleenhaus.com</a></p>
          </div>
          <div className="ct-info-block">
            <h3 className="ct-info-title">{lang === 'de' ? t('contact.info.call') : 'Call Us'}</h3>
            <p className="ct-info-text">+49 15567406041</p>
            <p className="ct-info-text-sub">{lang === 'de' ? t('contact.info.hours') : 'Mon – Sat, 10:00 AM – 7:00 PM IST'}</p>
          </div>
          <div className="ct-info-block">
            <h3 className="ct-info-title">{lang === 'de' ? t('contact.info.social') : 'Follow Us'}</h3>
            <div className="ct-socials">
              <a href="#" className="ct-social">Instagram</a>
              <a href="#" className="ct-social">LinkedIn</a>
              <a href="#" className="ct-social">Facebook</a>
            </div>
          </div>
        </div>

        <div className="ct-form-col" id="contact-form">
          {submitted ? (
            <div className="ct-success">
              <span style={{ fontSize: '52px' }}>✓</span>
              <h3>{lang === 'de' ? t('contact.form.successTitle') : 'Message Sent!'}</h3>
              <p>{lang === 'de' ? t('contact.form.successDesc') : "Thank you for reaching out. We'll get back to you within 24 hours."}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="ct-form-row">
                <input placeholder={lang === 'de' ? t('contact.form.name') : 'Your Name *'} required value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
                <input placeholder={lang === 'de' ? t('contact.form.email') : 'Email Address *'} type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
              </div>
              <div className="ct-form-row">
                <input placeholder={lang === 'de' ? t('contact.form.phone') : 'Phone Number'} type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
                <select value={form.subject} onChange={e => setForm({...form, subject: e.target.value})}>
                  <option value="">{lang === 'de' ? t('contact.form.subject') : 'Select Subject'}</option>
                  {(lang === 'de' ? t('contact.form.subjects') : [
                    { val: 'order', label: 'Order Inquiry' },
                    { val: 'custom', label: 'Custom Order' },
                    { val: 'trade', label: 'Trade Program' },
                    { val: 'shipping', label: 'Shipping' },
                    { val: 'other', label: 'Other' }
                  ]).map(opt => (
                    <option key={opt.val} value={opt.val}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <textarea placeholder={lang === 'de' ? t('contact.form.message') : 'Your Message *'} required rows="6" value={form.message} onChange={e => setForm({...form, message: e.target.value})}></textarea>
              {error && <p style={{ color: '#b42318', fontSize: '13px', margin: '0 0 16px', padding: '10px 14px', background: '#fee2e2', borderRadius: '6px', border: '1px solid #fecaca' }}>{error}</p>}
              <button type="submit" className="ct-submit" disabled={sending} style={sending ? { opacity: 0.6, cursor: 'not-allowed' } : {}}>
                {sending ? (lang === 'de' ? 'Wird gesendet...' : 'Sending...') : (lang === 'de' ? t('contact.form.submit') : 'Send Message')}
              </button>
            </form>
          )}
        </div>
      </section>

      <style>{contactStyles}</style>
    </div>
  );
}

const contactStyles = `
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,400;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap');
.ct-page { background: #fbfaee; }
.ct-label { display: block; font-family: 'Inter', sans-serif; font-size: 11px; font-weight: 600; letter-spacing: 2.5px; text-transform: uppercase; color: #785600; margin-bottom: 14px; }

/* Hero */
.ct-hero { text-align: center; padding: 60px 20px 50px; }
.ct-hero-title { font-family: 'Noto Serif', Georgia, serif; font-size: 3rem; font-weight: 400; color: #1b1c15; margin: 0 0 16px; line-height: 1.1; }
.ct-hero-sub { font-family: 'Inter', sans-serif; font-size: 15px; color: #4f4535; max-width: 500px; margin: 0 auto; line-height: 1.7; }

/* Main */
.ct-main { display: flex; gap: 60px; padding: 0 60px 80px; max-width: 1200px; margin: 0 auto; }
.ct-info-col { flex: 0.8; }
.ct-form-col { flex: 1.2; background: #f5f4e8; padding: 44px; border-radius: 4px; }

.ct-info-block { margin-bottom: 36px; }
.ct-info-title { font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: #785600; margin: 0 0 10px; }
.ct-info-text { font-family: 'Inter', sans-serif; font-size: 15px; color: #1b1c15; line-height: 1.7; margin: 0 0 4px; }
.ct-info-text a { color: #1b1c15; text-decoration: none; border-bottom: 1px solid #d3c4af; }
.ct-info-text a:hover { color: #785600; }
.ct-info-text-sub { font-family: 'Inter', sans-serif; font-size: 12px; color: #888; margin: 4px 0 0; }
.ct-socials { display: flex; gap: 16px; }
.ct-social { font-family: 'Inter', sans-serif; font-size: 13px; color: #1b1c15; text-decoration: none; border-bottom: 1px solid #d3c4af; padding-bottom: 2px; }
.ct-social:hover { color: #785600; }

/* Form */
.ct-form-row { display: flex; gap: 16px; margin-bottom: 20px; }
.ct-form-col input, .ct-form-col select, .ct-form-col textarea {
  width: 100%; padding: 14px 16px; border: none; border-bottom: 1.5px solid #d3c4af;
  background: transparent; font-family: 'Inter', sans-serif; font-size: 14px;
  outline: none; transition: border-color 0.3s; color: #1b1c15; box-sizing: border-box;
}
.ct-form-col select { appearance: none; cursor: pointer; color: #888; }
.ct-form-col input:focus, .ct-form-col select:focus, .ct-form-col textarea:focus { border-bottom-color: #785600; }
.ct-form-col textarea { resize: vertical; margin-bottom: 24px; }
.ct-submit {
  width: 100%; padding: 16px; background: linear-gradient(135deg, #785600, #986d00); color: #fff;
  border: none; font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 600;
  letter-spacing: 2px; text-transform: uppercase; cursor: pointer; border-radius: 4px; transition: opacity 0.3s;
}
.ct-submit:hover { opacity: 0.9; }
.ct-success { text-align: center; padding: 60px 20px; color: #785600; }
.ct-success h3 { font-family: 'Noto Serif', serif; font-size: 1.5rem; margin: 16px 0 8px; color: #1b1c15; }
.ct-success p { font-size: 14px; color: #4f4535; }

@media (max-width: 768px) {
  .ct-main { flex-direction: column; padding: 0 20px 40px; }
  .ct-form-col { padding: 30px 20px; }
  .ct-form-row { flex-direction: column; gap: 0; }
  .ct-form-row input, .ct-form-row select { margin-bottom: 20px; }
  .ct-hero-title { font-size: 2.2rem; }
}
`;
